import { useEffect } from 'react';
import useZustand from 'hooks/useZustand';

const addBodyClass = className => document.body.classList.add(className);
const removeBodyClass = className => document.body.classList.remove(className);

export default function useBodyClass(className) {
  const storedToken = useZustand('auth', 'token', false);

  // Add/remove fix-scrollbar class based on authentication
  // Scrollbar color is now controlled via CSS variable --primary-color set in App.jsx
  useEffect(() => {
    if (storedToken) {
      document.body.classList.remove('non-fix-scrollbar');
      document.body.classList.add('fix-scrollbar');
    } else {
      document.body.classList.remove('fix-scrollbar');
      document.body.classList.add('non-fix-scrollbar');
    }
  }, [storedToken]);

  // Handle additional custom classes (optional)
  useEffect(() => {
    if (!className) return;

    // Set up
    if (className instanceof Array) {
      className.forEach(addBodyClass);
    } else {
      addBodyClass(className);
    }

    // Clean up
    return () => {
      if (className instanceof Array) {
        className.forEach(removeBodyClass);
      } else {
        removeBodyClass(className);
      }
    };
  }, [className]);
}
